import { render, staticRenderFns } from "./PopupViewBookingsOnDeactivatedTables.vue?vue&type=template&id=56f36698&scoped=true&"
import script from "./PopupViewBookingsOnDeactivatedTables.vue?vue&type=script&lang=js&"
export * from "./PopupViewBookingsOnDeactivatedTables.vue?vue&type=script&lang=js&"
import style0 from "./PopupViewBookingsOnDeactivatedTables.vue?vue&type=style&index=0&id=56f36698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f36698",
  null
  
)

export default component.exports